import { render } from "./OnlineTTS.vue?vue&type=template&id=ae850c38&scoped=true"
import script from "./OnlineTTS.vue?vue&type=script&lang=js"
export * from "./OnlineTTS.vue?vue&type=script&lang=js"

import "./OnlineTTS.vue?vue&type=style&index=0&id=ae850c38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae850c38"]])

export default __exports__